<div class="card-modal p-2">
    <header class="card-gs-modal-header d-flex justify-content-between p-3">
        <h4 class="card-modal-title">
            {{ showSummary ? ('VEHICLE_DISABLE.SUMMARY_TITLE' | translate) : ('VEHICLE_DISABLE_SCHEDULE.TITLE' | translate) }}
        </h4>
            
        <button type="button" class="btn-close pull-right" aria-label="Close" (click)="bsModalRef.hide()"></button>
    </header>

    <content>
        <div *ngIf="!onApplyProgressStep && !showSummary">
            <p class="text-muted px-3">{{ 'VEHICLE_DISABLE_SCHEDULE.DESCRIPTION' | translate }}</p>
            <form class="mx-1" [formGroup]="form" (ngSubmit)="onSubmit()">
                <div class="row m-0 mb-4">
                    <!-- Time Slots -->
                    <div class="col-12">
                        <h5>{{ 'VEHICLE_DISABLE_SCHEDULE.TIME_SLOTS' | translate }}</h5>
                        
                        <!-- Fasce orarie -->
                        <div formArrayName="timeSlots">
                            @for (slot of timeSlotsFormArray.controls; track $index) {
                                <div [formGroupName]="$index" class="time-slot-row d-flex align-items-center mb-2">
                                    <select class="form-select me-2" formControlName="dayOfWeek">
                                        @for (day of weekDays; track day.id) {
                                            <option [value]="day.id">{{ day.name }}</option>
                                        }
                                    </select>
                                    
                                    <div class="d-flex align-items-center me-2">
                                        <input type="time" class="form-control" [value]="getTimeStringValue($index, 'startTime')" 
                                            (change)="onTimeChange($event, 'startTime', $index)">
                                        <span class="mx-2">-</span>
                                        <input type="time" class="form-control" [value]="getTimeStringValue($index, 'endTime')" 
                                            (change)="onTimeChange($event, 'endTime', $index)">
                                    </div>
                                    
                                    <button type="button" class="btn-outline-gs-danger" (click)="removeTimeSlot($index)" 
                                        [disabled]="timeSlotsFormArray.length <= 1">
                                        <i class="bi bi-trash"></i>
                                    </button>
                                </div>
                            }
                        </div>
                        
                        <button type="button" class="btn-outline-gs-primary" (click)="addTimeSlot()">
                            <i class="bi bi-plus"></i> {{ 'VEHICLE_DISABLE_SCHEDULE.ADD_TIME_SLOT' | translate }}
                        </button>
                    </div>
                </div>

                <div class="row m-0 mb-4">
                    <!-- Mesi attivi -->
                    <div class="col-12">
                        <div class="d-flex justify-content-between align-items-center mb-2">
                            <h5 class="mb-0">{{ 'VEHICLE_DISABLE_SCHEDULE.ACTIVE_MONTHS' | translate }}</h5>
                            <div class="form-check form-switch">
                                <input class="form-check-input" type="checkbox" role="switch" id="selectAllMonths" 
                                    (change)="toggleAllMonths($event)">
                                <label class="form-check-label text-secondary" for="selectAllMonths">
                                    {{ 'VEHICLE_DISABLE_SCHEDULE.SELECT_ALL_MONTHS' | translate }}
                                </label>
                            </div>
                        </div>
                        <div class="months-container d-flex flex-wrap" formArrayName="activeMonths">
                            @for (month of months; track month.id) {
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="checkbox" [formControlName]="month.id - 1" [id]="'month-' + month.id">
                                    <label class="form-check-label" [for]="'month-' + month.id">{{ month.name }}</label>
                                </div>
                            }
                        </div>
                    </div>
                </div>

                <div class="row m-0 mb-3">
                    <!-- Gruppi utente -->
                    <div class="col-12">
                        <h5>{{ 'VEHICLE_DISABLE_SCHEDULE.USER_GROUPS' | translate }}</h5>
                        <div class="my-3">
                            <user-group-autocomplete
                            (onSelectedItem)="onUserGroupSelected($event)" />
                            <p class="mt-2 text-muted">{{ 'VEHICLE_DISABLE_SCHEDULE.USER_GROUPS_DESCRIPTION' | translate }}</p>
                        </div>
                        
                        <div class="d-flex flex-wrap gap-2 mt-2" *ngIf="selectedUserGroups && selectedUserGroups.length > 0">
                            <button *ngFor="let group of selectedUserGroups" type="button" class="btn-gs-secondary-icon">
                                {{group.name}}
                                <button type="button" class="btn-close" aria-label="Close" (click)="removeUserGroup(group.id)"></button>
                            </button>
                        </div>
                    </div>
                </div>

                <div class="row m-0 mb-3">
                    <!-- Note -->
                    <div class="col-12">
                        <label for="note" class="form-label">{{ 'MODAL_VEHICLE_STATUS.NOTE' | translate }}</label>
                        <textarea id="note" class="form-control" rows="3" formControlName="note"></textarea>
                    </div>
                </div>

                <div class="row m-0 mt-4 pb-3">
                    <div class="col-12 d-flex justify-content-end">
                        <button type="button" class="btn-gs-secondary me-2" (click)="bsModalRef.hide()">
                            {{ 'ACTIONS.CANCEL' | translate }}
                        </button>
                        <button type="submit" class="btn-gs-primary" [disabled]="!form.valid">
                            {{ 'ACTIONS.SAVE' | translate }}
                        </button>
                    </div>
                </div>
            </form>
        </div>

        <!-- Barra di progresso -->
        <div *ngIf="onApplyProgressStep && !showSummary" class="m-4 d-flex flex-column gap-3">
            <p class="mb-2">{{ 'VEHICLE_DISABLE.PROCESSING_VEHICLES' | translate:{x: elementProcessed, y: totalElements} }}</p>
            <div class="progress" style="height: 10px;">
                <div class="progress-bar bg-success" role="progressbar" [style.width]="progressBarValue + '%'" 
                    aria-valuenow="progressBarValue" aria-valuemin="0" aria-valuemax="100"></div>
            </div>
            <div class="alert alert-warning mt-2">
                <i class="bi bi-exclamation-triangle me-2"></i> 
                {{ 'VEHICLE_DISABLE.ATTENTION_PROCESS_RUNNING' | translate }}
            </div>
        </div>

        <!-- Riepilogo risultati -->
        <div *ngIf="showSummary" class="m-4">
            <div class="d-flex flex-column gap-2 mb-4">
                <div class="d-flex gap-2 text-success">
                    <i class="bi bi-check-circle"></i> {{ 'VEHICLE_DISABLE_SCHEDULE.SUCCESS_COUNT' | translate:{count: successCount} }}
                </div>
                <div class="d-flex gap-2 text-danger">
                    <i class="bi bi-x-circle"></i> {{ 'VEHICLE_DISABLE_SCHEDULE.FAILURE_COUNT' | translate:{count: failureCount} }}
                </div>
            </div>

            <!-- Veicoli con operazione riuscita -->
            <div *ngIf="successCount > 0" class="mb-4">
                <h5 class="mb-3 text-success">{{ 'VEHICLE_DISABLE_SCHEDULE.SUCCESSFUL_VEHICLES' | translate }}</h5>
                <div class="list-group">
                    <div *ngFor="let result of processResults" class="list-group-item list-group-item-action" [class.list-group-item-success]="result.success">
                        <div *ngIf="result.success">
                            <i class="bi bi-check-circle-fill text-success me-2"></i>
                            <strong>{{ result.displayName }}</strong>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Veicoli con operazione fallita -->
            <div *ngIf="failureCount > 0" class="mb-4">
                <h5 class="mb-3 text-danger">{{ 'VEHICLE_DISABLE_SCHEDULE.FAILED_VEHICLES' | translate }}</h5>
                <div class="list-group">
                    <div *ngFor="let result of processResults" class="list-group-item list-group-item-action" [class.list-group-item-danger]="!result.success">
                        <div *ngIf="!result.success">
                            <div class="d-flex justify-content-between align-items-center">
                                <div>
                                    <i class="bi bi-x-circle-fill text-danger me-2"></i>
                                    <strong>{{ result.displayName }}</strong>
                                </div>
                            </div>
                            <small class="text-danger d-block mt-1">{{ result.errorMessage }}</small>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </content>
    
    <footer class="mb-3">
        <div class="d-flex justify-content-center mt-3" *ngIf="showSummary">
            <button type="button" class="btn-gs-primary" (click)="closeModal()">
                {{ 'ACTIONS.CLOSE' | translate }}
            </button>
        </div>
    </footer>
</div> 